import {styled} from '@mui/material';

export const AuthPaper = styled('div')(({theme}) => ({
  background: 'rgba(255, 255, 255, 0.3)',
  border: '1px solid #FFFFFF4D',
  borderRadius: '20px',
  borderBottomLeftRadius: '0',
  borderBottomRightRadius: '0',
  opacity: 1,
  backdropFilter: 'blur(32px)',
  padding: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
  },
}));
